import { render } from "./PricingListPage.vue?vue&type=template&id=21a6c5a6&scoped=true"
import script from "./PricingListPage.vue?vue&type=script&lang=js"
export * from "./PricingListPage.vue?vue&type=script&lang=js"

import "./PricingListPage.vue?vue&type=style&index=0&id=21a6c5a6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a6c5a6"]])

export default __exports__